import React, { useEffect }  from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import scrollToTop from "../components/hooks/ScrollToTop";
import './css/templates.css';

// Spam Policy component

const SpamPolicy = () => {
  const { t } = useTranslation();

    useEffect(() => {
      scrollToTop();
    }, []);

    useEffect(()=>{
    const html = document.getElementsByTagName('html')[0];
    html.setAttribute('data-wf-page', '68603f7a056ff6f78f58cb16');
    html.setAttribute('data-wf-site', '68603f7a056ff6f78f58cab1');
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require('ix2').init();
    document.dispatchEvent(new Event('readystatechange'))
    },[])
  return (
    <div >
      <div className="page-wrapper">
        <Navbar />
      <section className="blog-area">
        <div className="hero-wrapper hero-7 space" id="hero">
          <div className="container-space">
            <div className="row gx-4 align-items-center justify-content-between flex-row-reverse max-content-wraper">
              <div className="col-lg-12 col-md-6">
                <h3
                  className="text-center links-heading item-heading-font mb-0-5"
                  style={{ fontSize: "26px", color: "#ee7c2c" }}
                >
                  {t("spamPolicy")}
                </h3 >
                <div className="mt-4">
                  <h4 style={{ color: "#ee7c2c" }} className="mb-0-5">{t("whatIsSpam")}</h4>
                  <p className="mb-0-5">
                    {t("emailThatIsNotWanted")}
                    <Link
                      to="https://www.ftc.gov/tips-advice/business-center/guidance/can-spam-act-compliance-guide-business"
                      target="_blank"
                      className="orange-noa"
                    >
                      {t("canSpamAct")}
                    </Link>
                  </p>

                  <h4 style={{ color: "#ee7c2c" }} className="mb-0-5">{t("automatedSpam")}</h4>
                  <p className="mb-0-5">{t("theEaconomyMessaging")}</p>

                  <h4 style={{ color: "#ee7c2c" }} className="mb-0-5">{t("problemsWithSpam")}</h4>
                  <p className="mb-0-5">
                    {t("noMessageFilteringSystem")}
                    <Link to="https://www.mail-tester.com" target="_blank" className="orange-noa">
                      {t("mailTester")}
                    </Link>
                  </p>

                  <h4 style={{ color: "#ee7c2c" }} className="mb-0-5">{t("userSpam")}</h4>
                  <p className="mb-0-5">{t("eaconomyProvidesAFacility")}</p>

                  <h4 style={{ color: "#ee7c2c" }} className="mb-0-5">{t("receiptOfUnwanted")}</h4>
                  <p className="mb-0-5">{t("inTheUnlikelyEvent")}</p>

                  <h4 style={{ color: "#ee7c2c" }} className="mb-0-5">{t("changesToThis")}</h4>
                  <p className="mb-0-5">{t("eaconomyMayAmend")}</p>

                  <h4 style={{ color: "#ee7c2c" }} className="mb-0-5">{t("contactUs")}</h4>
                  <p className="mb-0-5">
                    {t("shouldYouHave")}
                    <Link to="mailto:support@joinnoa.io" className="orange-noa">
                      support@joinnoa.io
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
    </div>
  );
};

export default SpamPolicy;
